import { useCallback, useState } from 'react';
import styled from 'styled-components';

import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { ChevronRightIcon, Link, SidePanelContentSlot, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { medicalDataTranslationKeys, visitTranslationKeys } from '../../translations';

import { MedicalDataSidePanelContent } from './MedicalDataSidePanelContent';
import { MedicalDataSidePanelContentLoader } from './MedicalDataSidePanelContent.loader';
import { overwriteChronicDiseaseCounter } from './MedicalDataSidePanelContentSlot.utils';

type MedicalDataSidePanelContentSlotProps = {
   readonly patientId: number;
};

const StyledLink = styled(Link)`
   align-self: flex-end;
`;
StyledLink.displayName = 'Link';

export const MedicalDataSidePanelContentSlot = (props: MedicalDataSidePanelContentSlotProps): JSX.Element => {
   const [activeMedicalDataItem, setActiveMedicalDataItem] = useState<MedicalInformationCountByType | undefined>(
      undefined
   );
   const push = useHistoryPushWithBackAction(true);
   const goBackToMedicalDataPreview = (): void => {
      setActiveMedicalDataItem(undefined);
   };
   const goToPatientMedicalData = useCallback(
      () =>
         push(patientPaths.getMedicalDataPath({ params: { patientId: props.patientId }, searchParams: {} }), {
            label: visitTranslationKeys.goBackToVisit,
         }),
      [push, props.patientId]
   );

   return (
      <SidePanelContentSlot
         headerText={
            activeMedicalDataItem
               ? medicalDataTranslationKeys.categories[activeMedicalDataItem.type]
               : medicalDataTranslationKeys.medicalData
         }
         goBackLinkLabel={activeMedicalDataItem ? medicalDataTranslationKeys.goBackToMedicalData : undefined}
         onGoBackLinkClick={activeMedicalDataItem ? goBackToMedicalDataPreview : undefined}
      >
         <StyledLink
            testId={'goToPatientMedicalData'}
            iconSuffix={<ChevronRightIcon />}
            label={medicalDataTranslationKeys.goToMedicalData}
            onClick={goToPatientMedicalData}
         />
         <MedicalDataSidePanelContentLoader patientId={props.patientId}>
            {({ medicalInformationCountByType, chronicDiseaseCount, refetchMedicalInformationCountByType }) => (
               <MedicalDataSidePanelContent
                  patientId={props.patientId}
                  medicalData={overwriteChronicDiseaseCounter(medicalInformationCountByType, chronicDiseaseCount)}
                  activeMedicalDataItem={activeMedicalDataItem}
                  onItemHeaderClick={setActiveMedicalDataItem}
                  onMedicalDataAccessAuthorizationUpdate={refetchMedicalInformationCountByType}
               />
            )}
         </MedicalDataSidePanelContentLoader>
      </SidePanelContentSlot>
   );
};
